import { createAction } from 'redux-actions'
import { CLOSE_MODAL, OPEN_MODAL, ModalPayload } from './types'

// Modal
export const openModal = createAction<ModalPayload>(OPEN_MODAL)
export const closeModal = createAction(CLOSE_MODAL)
